import React, { useState, useEffect, useRef } from 'react';
import './Footer.css';
import logo from '../../assets/images/logo/logo.svg';
import instagramIcon from '../../assets/icons/instagram.svg';
import telegramIcon from '../../assets/icons/telegram.svg';
import whatsappIcon from '../../assets/icons/whatsapp.svg';
import dropdownArrow from '../../assets/icons/dropdown-arrow.svg';
import dropdownArrowHover from '../../assets/icons/dropdown-arrow_hover.svg';
import { Link } from 'react-router-dom';
import { Box } from '../common/Box/Box';
import { contactService } from '../../services/contactService';

const Footer = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [contacts, setContacts] = useState({
    emails: [],
    phones: [],
    socials: [],
    addresses: []
  });
  const dropdownTimeoutRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const data = await contactService.getContacts();
        const contactsData = data.contacts;
        
        setContacts({
          emails: contactsData.filter(c => c.type === 'email'),
          phones: contactsData.filter(c => c.type === 'phone'),
          socials: contactsData.filter(c => c.type === 'social'),
          addresses: contactsData.filter(c => c.type === 'address')
        });
      } catch (error) {
        console.error('Ошибка загрузки контактов:', error);
      }
    };
    fetchContacts();
  }, []);

  const handleMouseEnter = () => {
    setIsHovered(true);
    clearTimeout(dropdownTimeoutRef.current);
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    dropdownTimeoutRef.current = setTimeout(() => {
      setIsDropdownOpen(false);
    }, 200);
  };

  const handleMenuMouseEnter = () => {
    clearTimeout(dropdownTimeoutRef.current);
  };

  const handleMenuMouseLeave = () => {
    handleMouseLeave();
  };

  const getSocialIcon = (icon) => {
    switch(icon) {
      case 'instagram': return instagramIcon;
      case 'telegram': return telegramIcon;
      case 'whatsapp': return whatsappIcon;
      default: return null;
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-col footer-col-logo">
          <div className="footer-logo">
            <img src={logo} alt="Family Park" className="footer-logo-image" />
          </div>
          
          <div className="social-icons">
            {contacts.socials.map(social => (
              <a
                key={social.id}
                href={social.value}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <img src={getSocialIcon(social.icon)} alt={social.label} />
              </a>
            ))}
          </div>
        </div>
        
        <div className="footer-col footer-col-contact-info">
          <div className="footer-contact-section">
            <div className="contact-label">Электронная почта</div>
            {contacts.emails.map(email => (
              <div key={email.id} className="contact-item">
                <a href={`mailto:${email.value}`} className="contact-value">
                  {email.value}
                </a>
              </div>
            ))}
          </div>
          
          <div className="footer-contact-section">
            <div className="contact-label">Адрес</div>
            {contacts.addresses.length > 0 ? (
              contacts.addresses.map(address => (
                <div key={address.id} className="contact-item">
                  <span className="contact-value address-text">
                    {address.value}
                  </span>
                </div>
              ))
            ) : (
              <div className="contact-item">
                <span className="contact-value address-text">
                  Алматы, пр. Абая, 123
                </span>
              </div>
            )}
          </div>
        </div>
        
        <div className="footer-col footer-col-phones">
          <div className="contact-label">Контакты</div>
          <div className="footer-phones-list">
            {contacts.phones.length > 0 ? (
              contacts.phones.map((phone) => (
                <div key={phone.id} className="footer-phone-item">
                  <div className="phone-label">{phone.label}</div>
                  <a href={`tel:${phone.value.replace(/-/g, '')}`} className="phone-number">
                    {phone.value}
                  </a>
                </div>
              ))
            ) : (
              <>
                <div className="footer-phone-item">
                  <div className="phone-label">Аквапарк</div>
                  <a href="tel:+77011111111" className="phone-number">+7-701-111-11-11</a>
                </div>
                <div className="footer-phone-item">
                  <div className="phone-label">Парк</div>
                  <a href="tel:+77012222222" className="phone-number">+7-701-222-22-22</a>
                </div>
                <div className="footer-phone-item">
                  <div className="phone-label">Боулинг</div>
                  <a href="tel:+77013333333" className="phone-number">+7-701-333-33-33</a>
                </div>
              </>
            )}
          </div>
        </div>
        
        <div className="footer-col footer-col-nav">
          <Link to="/" className="footer-nav-link">Главная</Link>
          <Link to="/about" className="footer-nav-link">О парке</Link>
        </div>
        
        <div className="footer-col footer-col-nav">
          <div
            className="footer-dropdown-container"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            ref={dropdownRef}
          >
            <div className="footer-nav-link footer-dropdown">
              Развлечения
              <img
                src={isHovered ? dropdownArrow : dropdownArrowHover}
                alt="▼"
                className="footer-dropdown-arrow"
              />
            </div>
            
            {isDropdownOpen && (
              <div
                className="footer-dropdown-menu-wrapper"
                onMouseEnter={handleMenuMouseEnter}
                onMouseLeave={handleMenuMouseLeave}
              >
                <Box />
              </div>
            )}
          </div>
          
          <Link to="/news" className="footer-nav-link">Новости</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;